// Curated list of well-known services. Shared by the "Is this website down?" page and the
// SSL, DNS and domain tool pages, so every page has ONE definition of "curated".
// A per-domain tool page is indexable only for a domain on this list (see `isCuratedDomain`).

export type PopularSite = { domain: string; name: string; category: string }

export const POPULAR_SITES: PopularSite[] = [
  { domain: 'discord.com', name: 'Discord', category: 'Social' },
  { domain: 'youtube.com', name: 'YouTube', category: 'Social' },
  { domain: 'instagram.com', name: 'Instagram', category: 'Social' },
  { domain: 'facebook.com', name: 'Facebook', category: 'Social' },
  { domain: 'x.com', name: 'X (Twitter)', category: 'Social' },
  { domain: 'reddit.com', name: 'Reddit', category: 'Social' },
  { domain: 'tiktok.com', name: 'TikTok', category: 'Social' },
  { domain: 'netflix.com', name: 'Netflix', category: 'Streaming' },
  { domain: 'spotify.com', name: 'Spotify', category: 'Streaming' },
  { domain: 'twitch.tv', name: 'Twitch', category: 'Streaming' },
  { domain: 'gmail.com', name: 'Gmail', category: 'Productivity' },
  { domain: 'whatsapp.com', name: 'WhatsApp', category: 'Messaging' },
  { domain: 'store.steampowered.com', name: 'Steam', category: 'Gaming' },
  { domain: 'amazon.com', name: 'Amazon', category: 'Shopping' },
  { domain: 'github.com', name: 'GitHub', category: 'Developer' },
  { domain: 'chatgpt.com', name: 'ChatGPT', category: 'AI' },
  { domain: 'outlook.com', name: 'Outlook', category: 'Productivity' },
  { domain: 'roblox.com', name: 'Roblox', category: 'Gaming' },
  { domain: 'snapchat.com', name: 'Snapchat', category: 'Social' },
  { domain: 'slack.com', name: 'Slack', category: 'Productivity' },
  { domain: 'cloudflare.com', name: 'Cloudflare', category: 'Developer' },
  { domain: 'vercel.com', name: 'Vercel', category: 'Developer' },
  { domain: 'stripe.com', name: 'Stripe', category: 'Developer' },
  { domain: 'shopify.com', name: 'Shopify', category: 'Shopping' },
  { domain: 'notion.so', name: 'Notion', category: 'Productivity' },
  { domain: 'figma.com', name: 'Figma', category: 'Developer' },
  { domain: 'linkedin.com', name: 'LinkedIn', category: 'Social' },
  { domain: 'zoom.us', name: 'Zoom', category: 'Productivity' },
  { domain: 'claude.ai', name: 'Claude', category: 'AI' },
  { domain: 'openai.com', name: 'OpenAI', category: 'AI' },
]

const CURATED = new Set(POPULAR_SITES.map((s) => s.domain))

/** True when `domain` is on the curated list (case-insensitive). */
export function isCuratedDomain(domain: string): boolean {
  return CURATED.has(domain.trim().toLowerCase())
}

/** Registrable domains only (two labels). Domain-registration tools cannot look up a subdomain
 *  such as store.steampowered.com, so their per-domain pages use this subset. */
export const POPULAR_APEX_SITES: PopularSite[] = POPULAR_SITES.filter((s) => s.domain.split('.').length === 2)

/** True when `domain` is a curated registrable domain (for the domain-registration tools). */
export function isCuratedApexDomain(domain: string): boolean {
  const d = domain.trim().toLowerCase()
  return POPULAR_APEX_SITES.some((s) => s.domain === d)
}
